module.exports = __webpack_public_path__ + "img/Joe Willock.0cc78976.png";